import { render } from "./IngresosDiarios.vue?vue&type=template&id=02b6ed78"
import script from "./IngresosDiarios.vue?vue&type=script&lang=js"
export * from "./IngresosDiarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__